import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dashify'})
export class DashifyPipe implements PipeTransform {

  transform(value: string, ...args: any[]) {
    return value.replace(/(\s+\/\s+)|(\s+-\s+)|(\/)|(\s+)/g, '-').toLowerCase();
  }
}
